var config = {
  //本地路径
  apiUrl: 'https://ssx.fzjiading.com/api',//接口
  tymhUrl: '/apiMwcz',
  fileUrl: 'http://127.0.0.1:8758/upload/toJstUpload',
  fileShowUrl: 'https://ssx.fzjiading.com/jdminio/jdbucket1/',
  viewUrl: 'https://ssx.fzjiading.com/szdp-front2',
  qdUrl: 'https://ssx.fzjiading.com/api/'

  // apiUrl: 'https://dydg.qzwb.com/api',//接口
  // tymhUrl: '/apiMwcz',
  // fileUrl: 'https://dydg.qzwb.com/api/upload/toJstUpload',
  // fileShowUrl: 'https://dydg.qzwb.com/jdminio/jdbucket1/',
  // viewUrl: 'https://dydg.qzwb.com/',
  // qdUrl: 'https://dydg.qzwb.com/api/'

  // apiUrl: 'http://172.16.40.97:8093/api',//接口
  // tymhUrl: '/apiMwcz',
  // fileUrl: 'http://172.16.40.97:8093/api/upload/toJstUpload',
  // fileShowUrl: 'http://172.16.40.97:8093/jdminio/jdbucket1/',
  // viewUrl: 'http://172.16.40.97:8093/',
  // qdUrl: 'http://172.16.40.97:8093/api/'
};

export default config;
